module.exports = __webpack_public_path__ + "img/pic2.238b29c8.png";